import React, { FC, memo } from 'react';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import { useSetImageQuality } from '@hooks/useSetImageQuality';
import { IOption } from '../../services/stock/models/stockItems.service.model';
import { ROLES } from 'src/constants/main';
import { ImageSize } from '@utils/Image.utils';
import DynamicExteriorImagePreview from '@components/DynamicExteriorImagePreview';
import { useRouter } from 'next/router';
import routes from '../../constants/routes';
import {breakpoints} from "../../styles/theme";

const CarGalleryListItem: FC<{ url: string; quality: ImageSize }> = memo(({ url, quality }) => {
    const { carDetails } = useCarDetailsDuck();
    const router = useRouter();
    const img = useSetImageQuality(url, quality);

    const isBasketPage = router?.pathname?.includes(routes.BASKET);
    const isConfigPage = router?.pathname?.includes(routes.CAR);
    const isTrimPage = router.pathname?.includes(routes.SELECTOR);

    const imageAlt = `${carDetails?.model?.description} ${carDetails?.grBodyStyle?.description} ${
        carDetails?.exteriorColour?.title
    } ${carDetails?.interiorColour?.title}: ${carDetails?.options.map((option: IOption) => option.title)?.join(',')}`;

    const getMaxHeightByPage = () => {
        if (isBasketPage && window?.innerWidth > breakpoints.md) return '225px';
        if (isConfigPage || isTrimPage) return '600px';
    };

    return (
        <div className="image-wrapper" style={{ maxHeight: getMaxHeightByPage() }} role={ROLES.IMG}>
            <DynamicExteriorImagePreview imageUrl={img} />
        </div>
    );
});
CarGalleryListItem.displayName = 'CarGalleryImage';
export default CarGalleryListItem;
